import React, { useState } from "react";
import { useSelector } from "services/redux/rootReducer";
import styled from "styled-components";
import { ImportExportType } from "../../types/importExport";
import LabelWrapper from "./components/labelWrapper";
import SubmitButton from "./components/submitButton";

interface Props {
    onSubmitCallback: (data: any) => void;
}

const RawDataForm: React.FC<Props> = ({ onSubmitCallback }) => {
    const [textData, setTextData] = useState<string>("");
    const [fileData, setFileData] = useState<File>();
    const { importType } = useSelector(
        (state) => state.editor.importExportConfig
    );

    const handleRawDataChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextData(e.target.value);
    };

    const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file = e.target.files[0];
            if (importType === ImportExportType.JSON)
                setTextData(await file.text());
            if (importType === ImportExportType.EXCEL) setFileData(file);
        }
    };

    return (
        <StyledForm>
            <LabelWrapper label="Upload File">
                <input
                    type="file"
                    accept={
                        importType === ImportExportType.EXCEL
                            ? ".xlsx, .xls"
                            : ".json"
                    }
                    onChange={handleFile}
                />
            </LabelWrapper>
            {importType === ImportExportType.JSON ? (
                <LabelWrapper label="Raw Data">
                    <StyledRawData
                        value={textData}
                        onChange={handleRawDataChange}
                        autoComplete="off"
                    />
                </LabelWrapper>
            ) : null}
            <SubmitButton
                type="button"
                text="Import"
                onClick={() =>
                    onSubmitCallback(
                        importType === ImportExportType.JSON
                            ? textData
                            : fileData
                    )
                }
            />
        </StyledForm>
    );
};

const StyledForm = styled.div`
    overflow: auto;
    padding: 5%;
    color: ${(props) => props.theme.colors.neutral[800]};
`;

const StyledRawData = styled.textarea`
    height: 30vh;
    font-size: inherit;
`;

export default RawDataForm;
